import { useMemo } from "react";

export interface ConnectToolsStepText {
  stepLabelText: string;
  titleText: string;
  subtitleText: string;
  searchPlaceholderText: string;
  sidebarHeadingText: string;
  sidebarPoint1Text: string;
  sidebarPoint2Text: string;
  sidebarPoint3Text: string;
  sidebarPoint4Text: string;
  skipText: string;
}

const readText = (t: (key: string) => string, key: string): string => t(key);

export const useConnectToolsStepText = (
  t: (key: string) => string,
): ConnectToolsStepText =>
  useMemo(
    () => ({
      stepLabelText: readText(t, "wizard.step1.label"),
      titleText: readText(t, "wizard.step1.title"),
      subtitleText: readText(t, "wizard.step1.subtitle"),
      searchPlaceholderText: readText(t, "wizard.step1.searchPlaceholder"),
      sidebarHeadingText: readText(t, "wizard.step1.sidebarHeading"),
      sidebarPoint1Text: readText(t, "wizard.step1.sidebarPoint1"),
      sidebarPoint2Text: readText(t, "wizard.step1.sidebarPoint2"),
      sidebarPoint3Text: readText(t, "wizard.step1.sidebarPoint3"),
      sidebarPoint4Text: readText(t, "wizard.step1.sidebarPoint4"),
      skipText: readText(t, "wizard.step1.skip"),
    }),
    [t],
  );
